import { AddTrustDeviceParams, Device } from '@repo/user-types'
import { AxiosInstance, AxiosResponse } from 'axios'

export const addTrustDevice = async ({
  api,
  params,
}: {
  api: AxiosInstance
  params: AddTrustDeviceParams
}): Promise<AxiosResponse<Device[]>> => {
  return api.post<Device[]>(`/devices/trusted`, params)
}
